module.exports = __webpack_public_path__ + "static/media/robert.f540a5d7.png";